export const paths = {
  home: () => '/',
  signIn: () => '/sign-in',
  signInError: () => '/sign-in-error',
  signUp: () => '/sign-up',
  dashboard: () => '/d',
  settings: () => '/d/settings',
  settingsResumes: () => '/d/pitch/resumes',
  settingsAccount: () => '/d/settings',
  settingsNotifications: () => '/d/settings/notifications',
  settingsAppearance: () => '/d/settings/appearance',
  aboutUs: () => '/about-us',
  contactUs: () => '/contact-us',
  resumeBuilder: () => '/d/pitch/resumes/builder',
  services: () => '/services',
  blog: () => '/blog',
  terms: () => '/terms',
  privacy: () => '/privacy',
  admin: () => '/admin',
  adminCampaignsSettings: () => '/admin/campaigns-settings',
  adminUsersManagement: () => '/admin/users-management',
  adminBlog: () => '/admin/blog',
  redirect: () => '/redirect',
  brief: () => '/d/brief',
  welcome: () => '/welcome',
  search: () => '/search',
  simpleSearch: () => '/d/simple-search',

  // Career Tools
  dashboardJobs: () => '/d/research/jobs/search',
  dashboardJobsBrief: () => '/d/brief',
  dashboardJobsSource: (source: 'profile' | 'outreach' | 'report' | 'resume') => `/d/research/jobs/${source}`,
  reports: () => '/d/reports',
  reportDetail: (id: string) => `/d/reports/${id}`,
  contacts: () => '/d/contacts',
  companies: () => '/d/research/companies',
  hub: () => '/d/engage/inbox',
  hubOverview: () => '/d/engage/overview',
  hubKanban: () => '/d/engage/kanban',
  hubTable: () => '/d/engage/table',
  hubInbox: () => '/d/engage/inbox',
  hubResumes: () => '/d/pitch/resumes',
  hubTasks: () => '/d/engage/tasks',
  hubInterviews: () => '/d/engage/interviews',
  hubDetail: (id: string) => `/d/engage/inbox/${id}`,

  dContactDetail: (id: string) => `/d/contacts/${id}`,
  dCompanyDetail: (slug: string) => `/d/research/companies/${slug}`,
  dResumeBuilderDetail: (id: string) => `/d/pitch/resumes/builder/${id}`,
  dEngageConversation: (id: string) => `/d/engage/inbox/${id}`,

  universal: () => 'universal',

};

export const MARKETING_BLOCK_NAMES = {
  RIGHT_SIDE_BLOCK: "right_side_block",
  NAV_BAR_BLOCK: "nav_bar_block",
}

export const INTERNAL_SERVICES_PATHS = {
  "Document Tools": {
    "Document Builder": {
      "public_url": "/document-builder",
      "internal_url": "/app/documents",
      "additional_resources": [
        "/document-templates",
        "/document-examples"
      ],
      "help_url": "/help/document-builder"
    }
  },
  "Analytics Tools": {
    "Analytics Dashboard": {
      "public_url": "/analytics",
      "internal_url": "/app/analytics",
      "help_url": "/help/analytics"
    }
  }
}

export const getInternalAppUrl = (path: string | undefined) => {
  return `${process.env.NEXT_PUBLIC_INTERNAL_APP_HOST}${path || ""}`
}

// Job-related functions have been removed
